export const formatTime = (time?: string): string | undefined => {
  if (time === undefined) return undefined
  const date = time.split('T')[0]
  if (date !== undefined) {
    return date
  } else {
    return ''
  }
}
